import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2dfa407a&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=2dfa407a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa407a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dfa407a')) {
      api.createRecord('2dfa407a', component.options)
    } else {
      api.reload('2dfa407a', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=2dfa407a&scoped=true&", function () {
      api.rerender('2dfa407a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/login.vue"
export default component.exports